import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthLoginService {
  prefixPath = '/TokenAuth';
  basePath = `${environment.api_url_temp}${this.prefixPath}`;
  apiServiceOptions = { overrideBaseUrl: true };

  constructor(private apiService: ApiService) {

  }

  login(param: any, finalize?: VoidFunction): Observable<any> {
    return this.apiService.post(`${this.basePath}/AuthenticateNoTenant`, param, finalize, this.apiServiceOptions);
  }
  forgetPassword(param: any, finalize?: VoidFunction): Observable<any> {
    return this.apiService.post(`${this.basePath}/ResetPassword`, param, finalize, this.apiServiceOptions);
  }
  changePassword(param: any, finalize?: VoidFunction): Observable<any> {
    return this.apiService.post(`${this.basePath}/ChangePassword`, param, finalize, this.apiServiceOptions);
  }
  changeDefaultPassword(param: any, finalize?: VoidFunction): Observable<any> {
    return this.apiService.post(`${this.basePath}/ChangeDefaultPassword`, param, finalize, this.apiServiceOptions);
  }
  changePasswordProfile(param: any, finalize?: VoidFunction): Observable<any> {
    return this.apiService.post(`${this.basePath}/ChangePasswordProfile`, param, finalize, this.apiServiceOptions);
  }
}
